import { PropsWithChildren, useCallback, useEffect, useMemo, useState } from 'react';
import { signOut } from 'firebase/auth';
import { AuthenticationInfo } from '@/model/auth';
import { firebaseAuth } from '@/services/firebase';
import { IAuthContext, AuthContext } from './AuthContext';
import {
  getAuthenticationInfoFromStorage,
  updateAuthenticationInfoStorageReference,
} from './utils/getAuthenticationInfoFromStorage';

export const AuthContextProvider = ({ children }: PropsWithChildren) => {
  const [authenticationInfo, setAuthenticationInfo] = useState<AuthenticationInfo | null>(getAuthenticationInfoFromStorage);

  useEffect(() => {
    updateAuthenticationInfoStorageReference(authenticationInfo);
  }, [authenticationInfo]);

  const logout = useCallback(() => {
    // encerra a sessão do Firebase (ID token) além de limpar a sessão local
    signOut(firebaseAuth).catch(() => {});
    setAuthenticationInfo(null);
  }, []);

  const login = useCallback((authenticationInfo: AuthenticationInfo) => {
    setAuthenticationInfo(authenticationInfo);
  }, []);

  const value = useMemo<IAuthContext>(
    () => ({
      authenticationInfo,
      login,
      logout,
    }),
    [authenticationInfo, login, logout],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
